import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { DialogBase } from 't4core';
import { EntityAttachmentInfo } from '../../../../projects/t4core/src/public-api';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 't4-entity-attachment',
  templateUrl: './entityattachment.html',
  styleUrls: ['./entityattachment.css']
})

export class T4EntityAttachment extends DialogBase implements OnInit {
  public entityAttachments: EntityAttachmentInfo[] = [];
  public isLoading: boolean = false;
  public entityId: string;

  constructor(
    public dialogRef: MatDialogRef<T4EntityAttachment>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) {
    super("T4EntityAttachment");
    this.entityId = data.EntityId;
  }

  public async ngOnInit() {
    await this.loadData();
  }

  private async loadData() {
    this.isLoading = true;
    if (this.entityId) {
      try {
        this.entityAttachments = await this.Api.get<EntityAttachmentInfo[]>("/Data/GetEntityAttachments", { id: this.entityId });
      } catch (error) {
        console.error("Error loading attachments:", error);
      } finally {
        this.isLoading = false;
        this.cdr.detectChanges(); 
      }
    }
  }
}

